<template>
  <div>
    <custom-actions>
      <template #header> </template>
      <el-form
        :model="searchForm"
        ref="formData"
        inline
        class="global-form-label-width account-form"
        label-width="100px"
      >
        <el-form-item label="品种规格" prop="specName">
          <el-input
            clearable
            v-model="searchForm.specName"
            placeholder="请输入品种规格"
          />
        </el-form-item>
        <el-form-item label="是否展示" prop="isDisplay">
          <el-select v-model="searchForm.isDisplay" clearable>
            <el-option value="1" label="是"></el-option>
            <el-option value="2" label="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否散油" prop="isBulkOil">
          <el-select v-model="searchForm.isBulkOil" clearable>
            <el-option
              :value="item.value"
              :label="item.label"
              v-for="(item, index) of isBulkOilArr"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" label="规格图片" prop="specImage">
          <template v-slot="{ row }">
            <el-image
              v-if="row.specImage"
              style="width: 60px; height: 60px"
              :src="row.specImage"
              :preview-src-list="[row.specImage]"
              fit="cover"
            />
            <el-image
              v-else
              style="width: 60px; height: 60px"
              :src="YouImg"
              :preview-src-list="[YouImg]"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="120" label="价格差(元)" prop="priceDiff"></el-table-column>
        <el-table-column min-width="120" label="单价(元)" prop="currentPrice">
        </el-table-column>
        <el-table-column min-width="120" label="是否展示" prop="isDisplay">
          <template v-slot="{ row }">
            <el-tag v-if="row.isDisplay == 1" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="是否散油" prop="isBulkOil">
          <template v-slot="{ row }">
            {{ row.isBulkOil == "0" ? "否" : row.isBulkOil == "1" ? "是" : "" }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="单位" prop="unit"></el-table-column>
        <el-table-column width="200" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button
              type="text"
              v-if="hasEdit"
              @click="$router.push('/priceControl/edit?specId=' + row.specId)"
            >编辑</el-button>
            <el-button
              type="text"
              @click="$router.push('/priceControl/detail?specId=' + row.specId)"
            >详情</el-button>
            <el-button
              type="text"
              v-if="hasPrice"
              @click="onCustomerPrice(row)"
            >客户价格</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt15"
        :current-page.sync="page"
        background
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      >
      </el-pagination>
    </el-card>

    <!-- 新增：客户价格弹窗 -->
    <el-dialog title="新增客户价格" :visible.sync="customerPriceDlg" width="520px">
      <el-form ref="customerPriceFormRef" :model="customerPriceForm" :rules="customerPriceRules" label-width="110px">
<!--        <el-form-item prop="specId" label="specId">-->
<!--          <el-input v-model="customerPriceForm.specId" disabled></el-input>-->
<!--        </el-form-item>-->
        <el-form-item prop="userId" label="对应客户">
          <el-select v-model="customerPriceForm.userId" placeholder="请选择客户" style="width:100%" filterable>
            <el-option
              v-for="user in userList"
              :key="user.userId"
              :label="user.userName"
              :value="user.userId"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="currentPrice" label="单价(元)">
          <el-input-number v-model="customerPriceForm.currentPrice" :min="0" :precision="2" style="width:100%" placeholder="请输入单价"></el-input-number>
        </el-form-item>
        <el-form-item prop="numUp" label="数量">
          <el-input-number v-model="customerPriceForm.numUp" :min="0" style="width:100%" placeholder="请输入数量"></el-input-number>
        </el-form-item>
        <el-form-item prop="expireTime" label="失效时间">
          <el-date-picker
            v-model="customerPriceForm.expireTime"
            type="datetime"
            placeholder="请选择失效时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerPriceDlg = false">取消</el-button>
        <el-button type="primary" @click="submitCustomerPrice">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import YouImg from '../../assets/you.png'

export default {
  name: 'priceControl',
  mixins: [keepAlive],
  components: {},
  data() {
    // 失效时间自定义校验
    const validateExpireTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择失效时间'))
      }
      const selectTime = new Date(value).getTime()
      const now = Date.now()
      if (selectTime <= now) {
        callback(new Error('失效时间必须大于当前时间'))
      } else {
        callback()
      }
    }

    return {
      isBulkOilArr: [
        { label: '否', value: '0' },
        { label: '是', value: '1' }
      ],
      tableData: [],
      YouImg,
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        specName: '',
        isBulkOil: '',
        productCode: '',
        isDisplay: ''
      },
      showDlg: false,
      rowId: '',
      productCodeList: [],
      userList: [], // 用户下拉列表

      // 客户价格弹窗
      customerPriceDlg: false,
      customerPriceForm: {
        specId: '',
        userId: '',
        currentPrice: null,
        numUp: null,
        expireTime: ''
      },
      customerPriceRules: {
        userId: [{ required: true, message: '请选择对应客户', trigger: 'change' }],
        currentPrice: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        numUp: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        expireTime: [
          { required: true, trigger: 'change', validator: validateExpireTime }
        ]
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasPrice() {
      return this.buttonList.includes('price')
    }
  },
  created() {
    this.loadData()
    this.loadUser() // 加载客户下拉数据
  },
  methods: {
    // 获取客户下拉列表 userType=3
    loadUser() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        params: { userType: '3' }
      }).then(res => {
        this.userList = res.list || []
      })
    },
    loadData() {
      const params = {
        page: this.page,
        ...this.searchForm
      }
      console.log('params', params)
      this.$axios
        .get(this.$apis.priceControl.selectYxSpecPriceByList, {
          params: params
        })
        .then(res => {
          res.list.forEach(item => {
            item.currentPrice = ''
            if (item.priceList && item.priceList.length > 0) {
              if (item.priceList.length === 1) {
                item.currentPrice = item.priceList[0].specPrice
              } else {
                const nums = item.priceList.map(item => item.specPrice)
                const max = Math.max(...nums)
                const min = Math.min(...nums)
                item.currentPrice = min + ' ~ ' + max
              }
            }
          })
          this.tableData = res.list
          this.total = res.total
        })
    },
    loadDict() {
      this.$axios
        .get(this.$apis.common.selectDicByList, {
          params: { dicType: 'goodsCode' }
        })
        .then(res => {
          this.productCodeList = res.goodsCode || []
        })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.onSearch()
    },
    // 打开客户价格弹窗
    onCustomerPrice(row) {
      this.customerPriceDlg = true
      this.customerPriceForm.specId = row.specId
      this.customerPriceForm.userId = ''
      this.customerPriceForm.currentPrice = null
      this.customerPriceForm.numUp = null
      this.customerPriceForm.expireTime = ''
      this.$nextTick(() => {
        this.$refs.customerPriceFormRef.clearValidate()
      })
    },
    // 提交客户价格
    async submitCustomerPrice() {
      if (!this.$refs.customerPriceFormRef) return
      try {
        await this.$refs.customerPriceFormRef.validate()
      } catch (err) {
        return
      }
      this.loading = true
      this.$axios.post(this.$apis.priceControl.insertYxCurrentPrice, this.customerPriceForm)
        .then(() => {
          this.$message.success('新增成功')
          this.customerPriceDlg = false
          this.loadData()
        })
        .catch(() => {
          this.$message.error('新增失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss"></style>
